
angular.module('trainerWebApp.resources').factory('preferenceResource', ['$resource', 'errorHandler', function ($resource, errorHandler) {

  var PreferenceResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/trainer-home-preferences');

  PreferenceResource.prototype.savePreferences = function(value, resultCb, errorCb) {
    return PreferenceResource.save(value, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
  };

  return new PreferenceResource;
}]);
